import { render, staticRenderFns } from "./ProductsCart.vue?vue&type=template&id=59811104"
import script from "./ProductsCart.js?vue&type=script&lang=js&external"
export * from "./ProductsCart.js?vue&type=script&lang=js&external"
import style0 from "./ProductsCart.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports